import React, {ReactNode} from 'react';

import {ElementMouseEvent} from 'util/Types';

import {Cell} from './SimpleTable';

export interface LinkCellProps {
  children?: ReactNode;
  onClick: (e: ElementMouseEvent) => void;
}

export default function LinkCell({children, onClick}: LinkCellProps): JSX.Element {
  return (
    <Cell>
      <a onClick={onClick}>{children}</a>
    </Cell>
  );
}
